import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiListItemAvatar(_theme: Theme): MuiThemeComponentOverride<"MuiListItemAvatar"> {
  return { MuiListItemAvatar: { styleOverrides: { root: { minWidth: "unset" } } } };
}
